import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "list-marked",
  "use": "list-marked-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol viewBox=\"0 0 22 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"list-marked\"><path d=\"M0 1.094C0 .49.49 0 1.094 0h12.923a1.094 1.094 0 110 2.188H1.094C.49 2.188 0 1.698 0 1.093zm0 5.25C0 5.74.49 5.25 1.094 5.25h12.923a1.094 1.094 0 110 2.188H1.094A1.095 1.095 0 010 6.343zm10.4 3.274a1.25 1.25 0 10-1.753 1.781l4.534 4.463 7.59-7.471a1.25 1.25 0 00-1.754-1.782l-5.836 5.745-2.78-2.736zM6.443 10.5c-.006.57.159 1.108.557 1.5l.704.688h-6.61a1.094 1.094 0 110-2.188h5.349z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol